import React from "react";
import conttactUsBanner from "../../assets/img/inner-banner/Contact-Us.webp";
import { Container } from "react-bootstrap";
const ContactUsBanner = () => {
  return (
    <>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={conttactUsBanner}
            alt="Service banner"
            className="w-100 h-100 object-fit-cover about-banner-img"
          />
        </Container>
      </section>
    </>
  );
};

export default ContactUsBanner;
